import { Badge } from '@masterteam/mt-design-react'
import React from 'react'

function Projects({data, projectStatuses}) {
  return (
    <div>
    {data?.map((item, index) => <Badge
      className="project-badge"
      label="Badge"
      shape="circle"
      title="this is a primary Badge"
      variant="primary"
      size="small"
      key={index}
      backgroundColor={projectStatuses?.find((e) => item.Status === e?.Code)?.Color}
    >
      {item?.Count}
    </Badge>)}
    </div>
  )
}

export default Projects